import { Children, type ReactNode } from 'react';
import styled, { type CSSProperties } from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandXS } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const MainContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  gap: var(--double-unit);
  @media ${tabletAndAbove} {
    grid-template-columns: repeat(var(--count, 4), minmax(0, 1fr));
  }
`;

type Props = { title: ReactNode; children: ReactNode };
export const ListSection = ({ title, children }: Props) => {
  const count = Children.count(children);
  return (
    <Vertical gap={1.5}>
      <BrandXS color="var(--c-nd-700)">{title}</BrandXS>
      <MainContent style={{ '--count': Math.min(count, 4) } as CSSProperties}>
        {children}
      </MainContent>
    </Vertical>
  );
};
